import React from "react"
import { Link } from "react-router-dom"
import { DETAIL_PATH } from "configs/paths"
import defaultAvatar from "assets/img/default-avatar.png"
import "./index.css"

export default function ResultItem({ staffID, image, fullName,fullNameEN, dept, email, officeTel }) {
  const onError = (e) => {
    if (e.target.onerror === null) {
      e.target.src = defaultAvatar
    }
  }

  return (
    <div className="item">
      <div className="item-inner">
        <Link to={`${DETAIL_PATH}/${staffID}`} target="_blank">
          <img className="image" src={image} alt={`id-${staffID}`} 
            onError={onError} />
        </Link>
        <div className="detail">
          <div className="centered">
            <Link to={`${DETAIL_PATH}/${staffID}`} target="_blank">
              <div className="name">{fullName}</div>
              <div className="sub-name">{fullNameEN}</div>
            </Link>            
            <div className="dept">{dept}</div>
            <div className="contact">
              {
                email && (
                  <div className="email">{email}</div>
                )
              }
            </div>
            <div className="contact">
              {
                officeTel && (
                  <div className="phone">{" " + officeTel}</div>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}